import { RoutingService } from "./implementation";

export * from "./implementation";

export const routingService = new RoutingService();
